import { Form } from "react-bootstrap";

import styles from './form-group.module.scss';
import { useFormikContext } from "formik";

type FormGroupProps = {
    inputId: string;
    labelText: string;
    children: React.ReactNode;
}

export const FormGroup: React.FC<FormGroupProps> = ({
    inputId,
    labelText,
    children,
}) => {
    const { errors } = useFormikContext();
    const error = (errors as Record<string, string>)?.[inputId];
    const errorId = error ? `${inputId}-error` : null;

    return (
        <Form.Group className={styles.formGroupWrapper} {...errorId && { 'aria-describedby': errorId }}>
            <Form.Label className={styles.formGroupLabel} htmlFor={inputId}>{labelText}</Form.Label>
            {children}
            <div className={styles.formGroupErrorMessageWrapper}>
                {errorId && (
                    <span className={styles.formGroupErrorMessage} id={errorId}>{error}</span>
                )}
            </div>
        </Form.Group>
    )
}